export default {
  isAuthenthicated: state => !!state.token,
  menus: (state) => {
    let default_menu = [...state.sideMenu]
    return default_menu
  },
}
